/* BundleSection.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _40 = "._1xi2idpf{right:0}";
const _39 = "._94n5smyl{bottom:-28px}";
const _38 = "._p12finhd{max-width:41.8rem}";
const _37 = "._19pku2gc{margin-top:var(--ds-space-100,8px)}";
const _36 = "._k48p1fw0{font-weight:700}";
const _35 = "@media (min-width:48rem) and (max-width:63.99rem){._1b7e1ejb{margin-bottom:var(--ds-space-300,24px)}}";
const _34 = "._y3gn1h6o{text-align:center}";
const _33 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
const _32 = "._4cvr1h6o{align-items:center}";
const _31 = "._1bah1h6o{justify-content:center}";
const _30 = "@media (min-width:64rem){._dm251ule{display:block}}";
const _29 = "._1e0cglyw{display:none}";
const _28 = "._4t3i1qjk{height:37px}";
const _27 = "._1bsbhv4l{width:65%}";
const _26 = "._1ltvidpf{left:0}";
const _25 = "._154ismyl{top:-28px}";
const _24 = "._kqswstnw{position:absolute}";
const _23 = "._n3tdxncg{padding-bottom:var(--ds-space-800,4pc)}";
const _22 = "._ca0qxncg{padding-top:var(--ds-space-800,4pc)}";
const _21 = "._2lx21bp4{flex-direction:column}";
const _20 = "._bfhk1ret{background-color:#f8f8f8}";
const _19 = "@media (min-width:90rem){._1ccs1lce{padding:var(--ds-space-100,8px) 0 var(--ds-space-400,2pc)}._11sjewfl{overflow-x:visible}._z4l31q9c{flex-wrap:nowrap}._1aev1h6o{justify-content:center}._1yoqidpf{margin-left:0}}";
const _18 = "._1cicglyw::-webkit-scrollbar{display:none}";
const _17 = "._aetrb3bt:after{content:\"\"}";
const _16 = "._11w8exct:after{flex-basis:16px}";
const _15 = "._tua5idpf:after{flex-shrink:0}";
const _14 = "._u94kidpf:after{flex-grow:0}";
const _13 = "._4pckglyw{-ms-overflow-style:none}";
const _12 = "._1fjgglyw{scrollbar-width:none}";
const _11 = "._1bsb4diq{width:calc(100% + 40px)}";
const _10 = "._18u010v4{margin-left:var(--ds-space-negative-300,-24px)}";
const _9 = "._1reo1wug{overflow-x:auto}";
const _8 = "._2lx2vrvc{flex-direction:row}";
const _7 = "._1e0c1txw{display:flex}";
const _6 = "._1yt41nit{padding:var(--ds-space-100,8px) var(--ds-space-300,24px) var(--ds-space-400,2pc)}";
const _5 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { BodyLarge, BundleCard, FluidContainer, H3 } from '@atlassian/mpac-primitives';
import AngledVector from './assets/angled_vector.svg';
import AngledVectorDown from './assets/angled_vector_down.svg';
import CollabFlowBundleImage from './assets/collab_flow_bundle_tile.png';
import DevOpsBundleImage from './assets/devops_bundle_tile.png';
import QABundleImage from './assets/qa_bundle_tile.png';
import SupportFlowBundleImage from './assets/support_flow_bundle_tile.png';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "._kqswh2mm{position:relative}";
const _3 = "._1bsb1osq{width:100%}";
const _2 = "._18m915vq{overflow-y:hidden}";
const _ = "._1reo15vq{overflow-x:hidden}";
const BundleSectionStyle = null;
const SectionHeaderStyle = null;
const H3Style = null;
const DescriptionStyle = null;
const CardsContainerWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1reo15vq _18m915vq _1bsb1osq _kqswh2mm", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CardsContainerWrapper.displayName = 'CardsContainerWrapper';
}
const CardsContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulpxy5q _1yt41nit _1e0c1txw _2lx2vrvc _1reo1wug _18u010v4 _1bsb4diq _1fjgglyw _4pckglyw _u94kidpf _tua5idpf _11w8exct _aetrb3bt _1cicglyw _1ccs1lce _11sjewfl _z4l31q9c _1aev1h6o _1yoqidpf", __cmplp.className])
    }))]
  });
});

// Define bundle data
if (process.env.NODE_ENV !== 'production') {
  CardsContainer.displayName = 'CardsContainer';
}
const bundles = [{
  id: 'devops',
  title: 'DevOps Flow Essentials',
  category: 'DEVOPS',
  image: DevOpsBundleImage
}, {
  id: 'collaboration',
  title: 'Collaboration Flow Optimizer',
  category: 'COLLABORATION',
  image: CollabFlowBundleImage
}, {
  id: 'serviceManagement',
  title: 'Support Flow Optimizer',
  category: 'SERVICE MANAGEMENT',
  image: SupportFlowBundleImage
}, {
  id: 'testManagement',
  title: 'QA Track Power Suite',
  category: 'TEST MANAGEMENT',
  image: QABundleImage
}];
const AngledVectorStyle = null;
const AngledVectorDownStyle = null;
export const BundleSection = () => {
  const fireEvent = useAnalyticsEvents();
  const trackBundleCardClick = bundleId => {
    fireEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: 'bundleCardClick',
      attributes: {
        bundleId,
        source: 'homePage'
      }
    });
  };
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_20, _7, _21, _3, _22, _23, _4]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_bfhk1ret _1e0c1txw _2lx21bp4 _1bsb1osq _ca0qxncg _n3tdxncg _kqswh2mm"]),
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_24, _25, _26, _27, _28, _29, _30]
        }), /*#__PURE__*/_jsx("img", {
          src: AngledVector,
          alt: "angled vector",
          className: ax(["_kqswstnw _154ismyl _1ltvidpf _1bsbhv4l _4t3i1qjk _1e0cglyw _dm251ule"])
        })]
      }), /*#__PURE__*/_jsxs(FluidContainer, {
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_7, _31, _32, _33, _4, _34, _35]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1e0c1txw _1bah1h6o _4cvr1h6o _otyrxy5q _kqswh2mm _y3gn1h6o _1b7e1ejb"]),
            children: /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_36, _34]
                }), /*#__PURE__*/_jsx(H3, {
                  as: "h2",
                  className: ax(["_k48p1fw0 _y3gn1h6o"]),
                  children: "Explore bundles to power your workflow"
                })]
              }), /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_37, _34, _38]
                }), /*#__PURE__*/_jsx(BodyLarge, {
                  className: ax(["_19pku2gc _y3gn1h6o _p12finhd"]),
                  children: "See how a curated selection of apps can streamline tasks, boost productivity, and enhance collaboration in your team."
                })]
              })]
            })
          })]
        }), /*#__PURE__*/_jsx(CardsContainerWrapper, {
          children: /*#__PURE__*/_jsx(CardsContainer, {
            children: bundles.map(bundle => /*#__PURE__*/_jsx(BundleCard, {
              title: bundle.title,
              category: bundle.category,
              image: bundle.image,
              navigationUrl: "/bundles/".concat(bundle.id),
              onClick: () => trackBundleCardClick(bundle.id)
            }, bundle.id))
          })
        })]
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_24, _39, _40, _27, _28, _29, _30]
        }), /*#__PURE__*/_jsx("img", {
          src: AngledVectorDown,
          alt: "angled vector",
          className: ax(["_kqswstnw _94n5smyl _1xi2idpf _1bsbhv4l _4t3i1qjk _1e0cglyw _dm251ule"])
        })]
      })]
    })]
  });
};